import React from 'react';
import { observer } from 'mobx-react';
import BannerPcStudyPlanNotion from '../../../containers/courses/images/banner_pc_study_plan_notion.png';
import BannerSpStudyPlanNotion from '../../../containers/courses/images/banner_sp_study_plan_notion.png';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import './studyPlannningNotionBanner.module.scss';
import { NOTION_STUDY_PLANNING, V3Routes } from '../../../routes';

export const StudyPlanningNotionBanner = observer(() => {
  const { isSp } = useViewportState();
  return (
    <a href={V3Routes.home(NOTION_STUDY_PLANNING).stringify()} target="_blank">
      <img styleName="banner" src={isSp ? BannerSpStudyPlanNotion : BannerPcStudyPlanNotion} />
    </a>
  );
});
